import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusZone, FocusZoneDirection } from "azure-devops-ui/FocusZone";

interface IFocusOnMountExampleState {
    showFocusZone: boolean;
}

export default class FocusOnMountExample extends React.Component<{}, IFocusOnMountExampleState> {
    public constructor() {
        super({});
        this.state = { showFocusZone: false };
    }

    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <div style={{ marginBottom: "8px" }}>
                    <Button
                        text={this.state.showFocusZone ? "Unmount FocusZone" : "Mount FocusZone"}
                        onClick={() => {
                            this.setState({ showFocusZone: !this.state.showFocusZone });
                        }}
                    />
                </div>
                {this.state.showFocusZone && (
                    <FocusZone
                        defaultActiveElement="#myinput"
                        direction={FocusZoneDirection.Horizontal}
                        focusOnMount={true}
                    >
                        <div className="flex-row flex-center">
                            <div style={{ paddingRight: "8px" }}>
                                <Button text="Button1" />
                            </div>
                            <div style={{ paddingRight: "8px" }}>
                                <Button text="Button2" />
                            </div>
                            <div style={{ paddingRight: "8px" }}>
                                <input
                                    aria-label="Sample input"
                                    id="myinput"
                                    type="text"
                                    placeholder="Default Focus"
                                />
                            </div>
                            <div style={{ paddingRight: "8px" }}>
                                <Button text="Button3" />
                            </div>
                            <Button text="Button4" />
                        </div>
                    </FocusZone>
                )}
            </div>
        );
    }
}
